import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'region-groups',
  name: '地区群',
  icon: '地',
  group: '校友会组件',
  description: '展示同城或地区校友群。',
  defaultProps: {
    title: '地区群',
    limit: 6
}
}
